import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/SalonList.tsx");
